export const EMAIL_API_FAILURE_RESPONSE = "Failed to send email";